import React from "react";
import PropTypes from "prop-types";
import * as Sentry from "@sentry/react";
import Typography from "app/liveShopping/backoffice/otm/components/reusables/Typography";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    //logErrorToMyService(error, errorInfo);
    Sentry.captureException(error);
    Sentry.captureException(errorInfo);
    console.log("error", error);
    console.log("error info", errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      if (this.props.hidden) {
        return null;
      } else {
        return (
          <Typography variant="bodySB13" color="black">
            {this.props.customText}
          </Typography>
        );
      }
    }

    return this.props.children;
  }
}
ErrorBoundary.propTypes = {
  children: PropTypes.node,
  hidden: PropTypes.bool,
  customText: PropTypes.string,
};
ErrorBoundary.defaultProps = {
  hidden: true,
  customText: "Something went wrong.",
};
export default ErrorBoundary;
